import { BaseUser } from 'types';

export const getUserInitials = <U extends BaseUser>(user?: U) => {
  return `${user?.firstName?.charAt(0) ?? ''}${user?.lastName?.charAt(0) ?? ''}`.toUpperCase();
};
